<template>
  <div
    class="modal fade"
    id="customerModal"
    data-backdrop="static"
    tabindex="-1"
    role="dialog"
    aria-labelledby="customerModalLabel"
    aria-hidden="true"
  >
    <div
      class="modal-dialog modal-lg"
      role="document"
    >
      <div class="modal-content">
        <div class="modal-header">
          <h5
            v-if="isEmpty(customer.id)"
            class="modal-title"
            id="customerModalLabel"
          >เพิ่มลูกค้าใหม่</h5>
          <h5
            v-else
            class="modal-title"
            id="customerModalLabel"
          >
            แสดงข้อมูล
            <span class="text-primary">{{ customer.code }} {{ customer.name }}</span>
          </h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div
            v-if="!appearForm"
            class="well well-sm text-center"
          >
            <i class="fa fa-cog fa-spin fa-fw"></i>
            {{ message }}
          </div>
          <form
            v-else
            id="dataForm"
            @submit.prevent="saveData"
          >
            <div class="row">

              <div class="form-group col-sm-4">
                <label>รหัส*</label>
                <input
                  type="text"
                  class="form-control input-sm"
                  v-model.trim="customer.code"
                  placeholder=""
                />
              </div>
              <div class="form-group col-sm-8">
                <label>ชื่อ*</label>
                <input
                  type="text"
                  class="form-control input-sm"
                  v-model.trim="customer.name"
                  placeholder=""
                />
              </div>
            </div>
            <div class="form-group">
              <label>ที่อยู่*</label>
              <input
                type="text"
                class="form-control input-sm"
                v-model.trim="customer.address"
                placeholder=""
              />
            </div>
            <div class="row">
              <div class="form-group col-sm-4">
                <label>จังหวัด*</label>
                <vue-single-select
                  inputId="selected-province"
                  v-model="customer.province"
                  :options="provinces"
                  placeholder="เลือกจังหวัด"
                  :classes="{
                  wrapper: 'single-select-wrapper form-input-wrapper',
                  input: 'form-control',
                  icons: 'icons',
                  activeClass: 'active',
                  dropdown: 'dropdown'
                }"
                ></vue-single-select>
              </div>
              <div class="form-group col-sm-4">
                <label>เบอร์โทรศัพท์</label>
                <input
                  type="text"
                  class="form-control input-sm"
                  v-model.trim="customer.phone_number"
                  placeholder=""
                />
              </div>
              <div class="form-group col-sm-4">
                <label>เลขประจำตัวผู้เสียภาษี</label>
                <input
                  type="text"
                  class="form-control input-sm"
                  v-model.trim="customer.tax_number"
                  placeholder=""
                />
              </div>
            </div>

          </form>
        </div>
        <div class="modal-footer d-flex" v-if="appearForm">
          <button class="btn btn-danger" type="button"  @click="deleteCustomer"><i class="fa fa-trash"></i></button>
          <button
            class="btn btn-primary ml-auto"
            form="dataForm"
            :disabled="submitted || !valid"
          >บันทึกข้อมูล</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueSingleSelect from "vue-single-select";
import VCalendar from "v-calendar";
export default {
  components: {
    VCalendar,
    VueSingleSelect,
  },
  data() {
    return {
      appearForm: false,
      message: "กำลังดาวน์โหลดข้อมูล กรุณารอสักครู่",
      submitted: false,
      customer: {
        id: null,
        tax_number: null,
        code:null,
        name: null,
        address: null,
        provinces: [],
        phone_number: null,
      },
    };
  },
  created() {
    axios.get("/data/provinces.json")
    .then(
        response => {
            this.provinces = response.data;
        }
      )
      .catch(error => console.log(error));
  },
  mounted() {
    $("#customerModal").on("show.bs.modal", event => {
      this.appearForm = false;
      var button = $(event.relatedTarget);
      var id = button.data("id");

      if (id === undefined) {
        this.appearForm = true;
        return;
      }

      axios
        .get("/customers/" + id)
        .then(response => {
          this.customer = response.data;
          this.appearForm = true;
        })
        .catch(error => console.log(error));
    });

    $("#customerModal").on("hidden.bs.modal", event => {
      this.resetForm();
    });
  },
  methods: {
    isEmpty: str => !str || 0 === str.length,
    saveData: function() {
      this.disableForm();
      //เตรียมข้อมูล
      let formData = { ...this.customer };

      if (this.customer.id !== null) formData._method = "put";

      //ส่งข้อมูล
      axios
        .post(
          this.customer.id === null
            ? "/customers"
            : "/customers/" + this.customer.id,
          formData
        )
        .then(response => {
          $("#customerModal").modal("hide"); //hide model
          this.$emit("update-success");
        })
        .catch(error => {
          $("#customerModal").modal("hide"); //hide model
          this.$emit("update-fail");
        });
    },
    disableForm() {
      this.message = "กำลังดำเนินการ";
      this.submitted = true;
      this.appearForm = false;
    },
    resetForm() {
      this.customer = {
        id: null,
        tax_number: null,
        code:null,
        name: null,
        address: null,
        province: null,
        phone_number: null,
      };
      this.submitted = false;
      this.appearForm = true;
      this.message = "กำลังดาวน์โหลดข้อมูล กรุณารอสักครู่";
    },
    deleteCustomer() {
      if (!confirm("ยืนยันลบข้อมูลลูกค้า?")) {
        return;
      }
      axios
        .delete("/customers/" + this.customer.id)
        .then(response => {
          $("#customerModal").modal("hide"); //hide model
          this.$emit("update-success");
        })
        .catch(error => {
          $("#customerModal").modal("hide"); //hide model
          let message = error.response.data.message;
          this.$emit("update-fail", message);
        });
      // delete-success
    },
  },
  computed: {
    valid: function() {
      return (
        ! this.isEmpty(this.customer.code) &&
        ! this.isEmpty(this.customer.name) &&
        ! this.isEmpty(this.customer.address) &&
        ! this.isEmpty(this.customer.province)
      );
    },
  },
};
</script>
